import { render, staticRenderFns } from "./delivered-appart-add-or-update.vue?vue&type=template&id=5b0e5da8&scoped=true"
import script from "./delivered-appart-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivered-appart-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./delivered-appart-add-or-update.vue?vue&type=style&index=0&id=5b0e5da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e5da8",
  null
  
)

export default component.exports